<template>
  <div
    class="content-zone"
    :class="bbsMng.bfrAftrPstUseYn === 'Y' ? 'detail' : 'sch-full'"
  >
    <div class="content">
      <div class="scroll">
        <div class="form-box h_100">
          <div class="layout between form-box-title">
            <div>
              <p>{{ bbsCn.bbsNm }}</p>
            </div>
            <span>등록일시 | {{ bbsCn.regDt }}</span>
          </div>
          <div class="form-content grid-none overflow-y">
            <div ref="first">
              <div
                class="editor5"
                style="width: 100%; height: 100%"
                v-html="sanitizedContent"
              ></div>
            </div>
            <div class="layout border-top border-bottom pb10" ref="two">
              <p class="form-title">첨부파일</p>
              <div v-if="fileList.length == 0">
                <p>첨부된 파일이 없습니다.</p>
              </div>
              <ul v-else class="attach-file-wrap">
                <li v-for="(item, idx) in fileList" :key="idx" class="layout">
                  <p>{{ item.fileNm + "." + item.extnNm }}</p>
                  <button type="button"
                    class="btn-file-down"
                    @click="downloadFile(item)"
                  ><span>다운로드</span></button>
                </li>
              </ul>
            </div>
            <!-- 댓글 -->
            <div v-if="bbsMng.cmntUseYn == 'Y'" class="comment-box" ref="three">
              <div class="layout w_100 mb30">
                <p class="comment-head">댓글</p>
                <textarea
                  class="form-control sm border-none"
                  placeholder="댓글을 입력하세요."
                  v-model="InputCmnt"
                ></textarea>
                <button class="btn sm primary" @click="fnInsertCmnt">
                  등록
                </button>
              </div>
              <div class="comment-wrap">
                <template v-if="cmntList.length > 0">
                  <CommentItem
                    :comments="cmntList"
                    :pageAuth="pageAuth"
                    :pageId="pageId"
                    @isReply="isReply"
                  />
                </template>
                <template v-else>
                  <p class="data-none">등록된 댓글이 없습니다.</p>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="navigate-wrap" v-if="bbsMng.bfrAftrPstUseYn == 'Y'">
    <table class="content-navigate">
      <colgroup>
        <col width="10%" />
        <col width="90%" />
      </colgroup>
      <tbody>
        <tr>
          <td class="pd10 text-ct">다음글</td>
          <td v-if="nextBbsCn != null">
            <a :href="`${path}/view.page?pageId=${nextBbsCn.bbsId}`">{{
              fnSecretTitle(nextBbsCn)
            }}</a>
          </td>
          <td v-else class="pd10">다음글이 없습니다.</td>
        </tr>
        <tr>
          <td class="pd10 text-ct">이전글</td>
          <td v-if="prevBbsCn != null">
            <a :href="`${path}/view.page?pageId=${prevBbsCn.bbsId}`">{{
              fnSecretTitle(prevBbsCn)
            }}</a>
          </td>
          <td v-else class="pd10">이전글이 없습니다.</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="btn-wrap">
    <button class="btn sm tertiary" @click="fnList">목록</button>
    <button
      v-if="hasAccessByType('update', bbsCn.rgtr)"
      class="btn sm main"
      @click="fnUpdate"
    >
      수정
    </button>
    <button
      v-if="hasAccessByType('delete', bbsCn.rgtr)"
      class="btn sm red"
      @click="fnDelete"
    >
      삭제
    </button>
  </div>
</template>
<script>
import defaultAxios from "../../../../../../resources/js/defaultAxios.js";
import {
  findByBbsCn,
  del,
  updateVwCnt,
} from "../../../../../../resources/api/bbsCn.js";
import {
  saveCmnt,
  findCmntList,
} from "../../../../../../resources/api/cmnt.js";
import queryParams from "../../../../../../resources/js/queryParams.js";
import CommentItem from "../../../../../component/comment/CommentItem.vue";
import DOMPurify from "dompurify";
import "../../../../../component/ckeditor5/ckeditor.css";

export default {
  mixins: [queryParams],
  components: {},
  data() {
    return {
      path: this.$store.state.path,
      pageAuth: this.$store.state.pageAuth,
      mbrId: this.$store.state.mbrId,
      roles: this.$store.state.roles[0].authority,
      bbsMngId: null,
      bbsCn: {},
      bbsMng: {},
      wrtrNm: "",
      pageId: "",
      fileList: {},

      // 이전글 다음글
      prevBbsCn: {},
      nextBbsCn: {},

      // 댓글
      InputCmnt: "",
      upCmntId: null,
      cmnt: {},
      cmntList: [],
    };
  },
  created() {
    this.fnBbsIdExtraction();
    this.fnIdExtraction();
    this.fnSelectOne();
    this.getCmntList();
  },
  methods: {
    // 상세조회
    async fnSelectOne() {
      try {
        const params = {
          bbsId: this.pageId,
          bbsMngId: this.bbsMngId,
        };
        const res = await findByBbsCn(params);
        if (res.status == 200) {
          // 권한이 없는경우
          if (this.pageAuth.inqAuthrt != "Y") {
            this.fnList();
            alert("읽기 권한이 없습니다.");
            return;
          }
          // 권한은 있으나 비밀 글인 경우
          if (res.data.data.bbsCn.prvtPstYn == "Y") {
            if (
              res.data.data.bbsCn.rgtr != this.mbrId &&
              this.roles != "ROLE_ADMIN"
            ) {
              this.fnList();
              alert("읽기 권한이 없습니다.");
              return;
            }
          }

          this.bbsCn = res.data.data.bbsCn;
          this.bbsMng = res.data.data.bbsMng;
          this.wrtrNm = this.bbsCn.rgtrNm; // 작성자
          this.fileList = res.data.data.fileList;
          this.prevBbsCn = res.data.data.prevBbsCn;
          this.nextBbsCn = res.data.data.nextBbsCn;

          this.updateVwCnt();
          const fileExtension = this.fileList.map((file) => file.extnNm);
        }
      } catch (error) {
        const errorData = error.response.data;
        if (errorData.message != null && errorData.message != "") {
          alert(error.response.data.message);
        } else {
          alert("에러가 발생했습니다.\n관리자에게 문의해주세요.");
        }
      }
    },
    // 댓글 조회
    async getCmntList() {
      try {
        const params = {
          bbsId: this.$route.query.pageId,
        };
        const res = await findCmntList(params);
        if (res.status == 200) {
          this.cmntList = res.data.data.cmntList;
        }
      } catch (error) {
        const errorData = error.response.data;
        if (errorData.message != null && errorData.message != "") {
          alert(error.response.data.message);
        } else {
          alert("에러가 발생했습니다.\n관리자에게 문의해주세요.");
        }
      }
    },
    // 첨부파일 다운로드 로직
    async downloadFile(file) {
      if (this.pageAuth.fileDwnldAuthrt != "Y") {
        alert("다운로드 권한이 없습니다.");
        return;
      }
      try {
        const response = await defaultAxios({
          url: "/sys/file/fileDownload.json", // URL 경로 확인
          method: "post",
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
            Authorization: this.$store.state.authorization,
          },
          data: file.fileId,
          responseType: "blob",
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", file.fileNm + "." + file.extnNm);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        const errorData = error.response.data;
        if (errorData.message != null && errorData.message != "") {
          alert(error.response.data.message);
        } else {
          alert("파일 다운로드 중 오류가 발생했습니다.");
        }
      }
    },
    // 목록으로 이동
    fnList() {
      this.$router.push({
        path: this.path + "/list.page",
      });
    },
    // 수정으로 이동
    fnUpdate() {
      this.$router.push({
        path: this.path + "/insert.page",
        query: {
          pageId: this.bbsCn.bbsId,
        },
      });
    },
    // 페이지 이동
    fnMoveBbsCn(bbsId) {
      this.$router.push({
        path: this.path + "/view.page",
        query: {
          pageId: bbsId,
        },
      });
    },
    // 이전글/다음글 비밀글 제목 마스킹 (열람 권한 없으면 [ 비밀글입니다 ])
    fnSecretTitle(bbsCn) {
      if (bbsCn == null) {
        return "";
      }
      if (bbsCn.prvtPstYn === "Y") {
        const isAdmin = this.hasAccessByType("manage");
        const isRegister = bbsCn.rgtr === this.$store.state.mbrId;
        if (!isAdmin && !isRegister) {
          return "[ 비밀글입니다 ]";
        }
      }
      return bbsCn.bbsNm;
    },
    // 삭제
    async fnDelete() {
      if (!confirm("삭제하시겠습니까?")) {
        return;
      }
      try {
        this.bbsCn.useYn = "N";
        const res = await del(this.bbsCn);
        alert(res.data.message);
        if (res.status == 200) {
          this.$router.push({
            path: this.path + "/list.page",
          });
        }
      } catch (error) {
        const errorData = error.response.data;
        if (errorData.message != null && errorData.message != "") {
          alert(error.response.data.message);
        } else {
          alert("에러가 발생했습니다.\n관리자에게 문의해주세요.");
        }
      }
    },
    // 조회수 증가
    async updateVwCnt() {
      try {
        const params = {
          bbsId: this.pageId,
        };
        const res = await updateVwCnt(params);
      } catch (error) {
        const errorData = error.response.data;
        if (errorData.message != null && errorData.message != "") {
          alert(error.response.data.message);
        } else {
          alert("에러가 발생했습니다.\n관리자에게 문의해주세요.");
        }
      }
    },

    // 댓글 등록 로직
    async fnInsertCmnt() {
      // 유효성 검사
      if (this.InputCmnt.trim() == "" || this.InputCmnt == null) {
        alert("댓글을 입력해주세요.");
        return;
      }
      try {
        const params = {
          bbsId: this.pageId,
          cmntCn: this.InputCmnt,
          upCmntId: this.upCmntId,
        };
        const res = await saveCmnt(params);
        if (res.status == 200) {
          alert("댓글이 등록되었습니다.");
          this.InputCmnt = "";
          this.upCmntId = null;
          this.getCmntList();
        }
      } catch (error) {
        const errorData = error.response.data;
        if (errorData.message != null && errorData.message != "") {
          alert(error.response.data.message);
        } else {
          alert("에러가 발생했습니다.\n관리자에게 문의해주세요.");
        }
      }
    },
    isReply(isReply) {
      this.getCmntList();
    },
    updateHeight() {
      this.$nextTick(() => {
        const first = this.$refs.first;
        const two = this.$refs.two;
        const three = this.$refs.three;

        let total = 0;
        if (two) total += two.offsetHeight;
        if (three) total += three.offsetHeight;

        if (first) {
          first.style.minHeight = `calc(100% - ${total}px - 30px)`;
          first.style.maxHeight = `auto`;
        }
      });
    },
  },
  watch: {
    bbsMng: {
      handler() {
        this.$nextTick(() => {
          this.updateHeight();
        });
      },
      deep: true,
    },
  },
  computed: {
    sanitizedContent() {
      return DOMPurify.sanitize(this.bbsCn.bbsCn, {
        ADD_TAGS: ["oembed"],
        ADD_ATTR: ["url"],
      });
    },
    downloadFilePath() {
      return this.$iconPath("mdiDownload");
    },
  },
  components: {
    CommentItem: CommentItem,
  },
  mounted() {
    this.updateHeight();

    // 창 크기 변경 시에도 대응하고 싶다면:
    window.addEventListener("resize", this.updateHeight);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateHeight);
  },
};
</script>
